import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { authService } from '../../services/auth';
import { toastService } from '../../services/toast';
import AdminLogin from './AdminLogin';
import GatewayPage from './GatewayPage';

// مكون آمن للدخول للوحة التحكم - يعرض بوابة دخول أولاً ثم صفحة تسجيل الدخول
const SecureAdminLogin = () => {
  const [showLogin, setShowLogin] = useState(false);
  const [isAnimating, setIsAnimating] = useState(false);
  const navigate = useNavigate();

  // التحقق من تسجيل الدخول
  useEffect(() => {
    const checkAuthStatus = async () => {
      try {
        const token = localStorage.getItem('token');
        // التحقق من وجود صلاحية دخول لوحة التحكم
        const permissions = JSON.parse(localStorage.getItem('customPermissions') || '[]');
        
        if (token && permissions.includes('access_dashboard')) {
          navigate('/admin/dashboard');
        }
      } catch (error) {
        console.error('خطأ في التحقق من حالة تسجيل الدخول:', error);
      }
    };
    
    checkAuthStatus();
  }, [navigate]);

  // عند اجتياز بوابة الكود
  const handleGatewaySuccess = () => {
    setIsAnimating(true);
    setTimeout(() => {
      setShowLogin(true);
      setIsAnimating(false);
    }, 1000);
  };

  return (
    <div className="min-h-screen overflow-hidden">
      <AnimatePresence mode="wait">
        {!showLogin ? (
          <motion.div
            key="gateway"
            initial={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            animate={isAnimating ? { opacity: 0 } : { opacity: 1 }}
            transition={{ duration: 0.8, ease: "easeInOut" }}
            className="w-full h-full"
          >
            <GatewayPage onSuccess={handleGatewaySuccess} />
          </motion.div>
        ) : (
          <motion.div
            key="login"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.5 }}
            className="w-full h-full"
          >
            <AdminLogin />
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default SecureAdminLogin;
